export interface INameHistoryItem {
	forename: string;
	surname: string;
	middleNames: string;
	startAt: string | Date | null;
	endAt: string | Date | null;
	nameType: string;
	uuid: string;
	createdAt?: string;
}

export interface ILicenceItem {
	uuid: string;
	name: string;
	surname: string;
	number: string;
	role: string;
	sector: string;
	status: string;
	type: string;
	expiry_date: string | Date | null;
	expiryDate: string | Date | null;
	frontReadUrl: string;
	backReadUrl: string;
	fileNameFront: string;
	fileNameBack: string;
}

export interface IAddressHistoryItem {
	uuid?: string;
	startAt: string | Date | null;
	endAt: string | Date | null;
	streetAddress: string;
	city: string;
	postcode: string;
	country: string;
}

export interface IAddressHistoryItemDb {
	type?: string;
	gapDays?: number;
	address: IAddress;
	uuid?: string;
	startAt: string | Date | null;
	endAt: string | Date | null;
	isCurrent?: boolean;
}

export interface IActivityItem {
	endAt: string | Date | null;
	startAt: string | Date | null;
	overlap: boolean;
	type: string;
	name: string;
	isPartTime: boolean;
	uuid: string;
	address: IAddress;
	files: IFileItem[];
	jobTitle?: string;
	canContactEmployer: boolean;
	reasonForLeaving: string;
	reasonForLeavingText: string;
	originalUuid: string;
	verifiedAt: string | Date;
	email: string;
	reference: IReference;
	careerBreakReason: string;
	careerBreakReasonType: string;
	gapDays?: number;
	createdAt?: string;
}

export interface IActivityFormState {
	uuid: string;
	type: string;
	jobTitle?: string;
	startAt: null | Date | string;
	endAt: null | Date | string;
	name: string;
	email: string;
	address: string;
	city: string;
	postcode: string;
	region?: string;
	country: string;
	canContactEmployer: boolean;
	isPartTime: boolean;
}

export interface IReference {
	addedManually: boolean;
	status: string;
	writtenAttempts: number;
}

export interface IFileItem {
	status: string;
	originalStatus: string;
	readUrl: string;
	writeUrl: string;
	fileUrl: string;
	uuid: string;
	deletedAt: string | null;
	fileName: string;
	name: string;
	type: string;
	tags?: string | string[];
}

export interface IAddress {
	uuid?: string;
	streetAddress: string;
	city: string;
	postcode: string;
	region?: string;
	country: string;
	address?: string;
}

export interface IDisclosure {
	uuid: string;
	questionUuid: string;
	sentence: string;
	date: string | Date | null;
	details: string;
	type: string;
	createdAt: string;
}

export interface IApplicant {
	uuid: string;
	workerUuid: string;
	name: string;
	surname: string;
	contactNumber: string;
	gender: string;
	email: string;
	DOB: null | string | Date;
	nationalInsuranceNumber: string;
	provisionallyCleared?: string | null;
	finalStatus?: string | null;
}

export interface IStepComplete {
	title: string;
	status: string;
	tag: string;
}
export interface IShareCode {
	shareCode: string;
	dob: any;
}

export interface IRtwImageData {
	type: string;
	facingMode: string;
	data: string;
}

export interface ISiaLicenceData {
	number: string;
}

export interface RtwIdCheck {
	page: string;
	checkName: string;
	status: string;
}

export interface IShareFile {
	email: string;
}

export interface ICandidateStatus {
	id: number;
	name: string;
	bucket: string;
}

// List of Candidate Statuses that are updated through Candidate Portal
export const CandidateStatusEnum = {
	INVITE_ACCEPTED: 'Invite Accepted',
	ONBOARDING_STARTED: 'Onboarding Started',
	CHECK_STARTED: 'Check Started',
	IN_REVIEW: 'In Review',
}

export enum CheckType {
	RTW = 'rtw',
	BS7858 = 'bs7858',
	RTWBS7858 = 'rtwbs7858',
}